import { Component, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CardConfiguration, IPlatform, IOrganisation } from '@bciti/types';
import { ToastrService } from 'ngx-toastr';
import { of, Subject } from 'rxjs';
import { catchError, takeUntil, tap } from 'rxjs/operators';
import { ConfigurationType } from '@bciti/types';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';
@Component({
    selector: 'app-cards',
    templateUrl: './cards.component.html',
    styleUrls: ['./cards.component.scss'],
})
export class CardsComponent implements OnInit, OnDestroy {
    destroy$ = new Subject();
    organisations: IOrganisation[];
    selectedOrganisation: string;
    cards: CardConfiguration[];
    loading = false;
    tag: string;
    config: IPlatform;

    @Output()
    errors: Array<object>;

    constructor(private configurationService: ConfigurationService, private route: ActivatedRoute, private toast: ToastrService) {}

    ngOnInit(): void {
        this.route.params.subscribe((param) => {
            if (param.tag) {
                this.tag = param.tag;
                this.configurationService.getConfigurationByKey(this.tag, ConfigurationType.PLATFORM).subscribe((platform) => {
                    this.config = platform;
                });
            }
        });
    }

    updateCards(cardsArray: CardConfiguration[]) {
        this.loading = true;

        if (!this.validateCards(cardsArray)) {
            this.toast.error('Your form contains errors. Please verify your data.');
            this.loading = false;
        } else {
            if (!this.config.support) {
                this.config.support = { cards: [] };
            }
            if (this.config.primaryCard && Object.keys(this.config.primaryCard).length === 0) {
                delete this.config.primaryCard;
            }
            const payload = {
                configuration: {
                    key: ConfigurationType.PLATFORM,
                    data: this.config,
                },
            };

            payload.configuration.data.support = {
                ...payload.configuration.data.support,
                ...{ cards: cardsArray },
            };

            if (this.tag != 'BROSSARD') {
                this.config.frenchLanguageCharterBanner = false;
            }

            this.configurationService
                .patchConfigurations(this.tag, payload)
                .pipe(
                    takeUntil(this.destroy$),
                    tap((configuration) => {
                        this.config = configuration.data;
                        this.toast.success(`Cards for <b>${this.tag}</b> were updated`, 'Success', { enableHtml: true });
                    }),
                    tap(() => (this.loading = false)),
                    catchError((error) => {
                        this.toast.error('An error occured. View browser console for details', 'Error');
                        console.log('error', error);
                        this.loading = false;
                        return of();
                    }),
                )
                .subscribe();

            this.loading = false;
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    validateCards(cardsArray: CardConfiguration[]): boolean {
        let valid = true;

        this.errors = Array.from({ length: cardsArray.length }, () => ({
            requiredCards: false,
            enableCards: false,
        }));

        const cardsInfo = Object.assign(
            {},
            ...cardsArray.map((card, index) => ({
                [card.type]: {
                    arrayIndex: index,
                    enableCards: card.enableCards,
                    requiredCards: card.requiredCards,
                },
            })),
        );

        // Checks if the required cards are present and if the associated 'enable cards' relation exists
        Object.entries(cardsInfo).forEach(([cardType, value]) => {
            const arrayIndexKey = 'arrayIndex';
            const requiredCardKey = 'requiredCards';
            const enableCardsKey = 'enableCards';

            value[requiredCardKey].forEach((requiredCard) => {
                if (!(requiredCard in cardsInfo)) {
                    this.errors[value[arrayIndexKey]][requiredCardKey] = true;
                    valid = false;
                } else {
                    const targetRequiredCard = cardsInfo[requiredCard];

                    if (!targetRequiredCard[enableCardsKey].includes(cardType)) {
                        this.errors[targetRequiredCard[arrayIndexKey]][enableCardsKey] = true;
                        valid = false;
                    }
                }
            });
        });

        return valid;
    }
}
